// NOTE JUMP
// cm 기준
const DEFAULT_MIN_JUMP_HEIGHT = 5
const DEFAULT_MAX_JUMP_HEIGHT = 1000
const DEFAULT_LOW_JUMP_HEIGHT = 10
const DEFAULT_MEDIUM_JUMP_HEIGHT = 30
const DEFAULT_HIGH_JUMP_HEIGHT = 50
const DEFAULT_JUMP_VALUE = {
  lowJumpHeight: DEFAULT_LOW_JUMP_HEIGHT,
  mediumJumpHeight: DEFAULT_MEDIUM_JUMP_HEIGHT,
  highJumpHeight: DEFAULT_HIGH_JUMP_HEIGHT,
  minJumpHeight: DEFAULT_MIN_JUMP_HEIGHT,
  maxJumpHeight: DEFAULT_MAX_JUMP_HEIGHT,
}

// NOTE COD
// m/s^2 기준
const DEFAULT_MIN_COD_ACCEL = 1.5
const DEFAULT_MAX_COD_ACCEL = 10
const DEFAULT_LOW_COD_ACCEL = 2
const DEFAULT_MEDIUM_COD_ACCEL = 3
const DEFAULT_HIGH_COD_ACCEL = 4
const DEFAULT_COD_VALUE = {
  lowCODAccel: DEFAULT_LOW_COD_ACCEL,
  mediumCODAccel: DEFAULT_MEDIUM_COD_ACCEL,
  highCODAccel: DEFAULT_HIGH_COD_ACCEL,
  minCODAccel: DEFAULT_MIN_COD_ACCEL,
  maxCODAccel: DEFAULT_MAX_COD_ACCEL,
}

// NOTE DIVE
const DEFAULT_ROLL_ANGLE_THRESHOLD = 60
const MINIMUM_ROLL_ANGLE_THRESHOLD = 30
const MAXIMUM_ROLL_ANGLE_THRESHOLD = 90

// NOTE ACTION
const DEFAULT_ACTIONS_VALUE = {
  run: null,
  acceleration: null,
  deceleration: null,
  jump: null,
  cod: null,
  dive: null,
}

export {
  DEFAULT_HIGH_JUMP_HEIGHT,
  DEFAULT_LOW_JUMP_HEIGHT,
  DEFAULT_MEDIUM_JUMP_HEIGHT,
  DEFAULT_MIN_JUMP_HEIGHT,
  DEFAULT_MAX_JUMP_HEIGHT,
  DEFAULT_JUMP_VALUE,
  DEFAULT_HIGH_COD_ACCEL,
  DEFAULT_LOW_COD_ACCEL,
  DEFAULT_MEDIUM_COD_ACCEL,
  DEFAULT_MIN_COD_ACCEL,
  DEFAULT_MAX_COD_ACCEL,
  DEFAULT_COD_VALUE,
  DEFAULT_ROLL_ANGLE_THRESHOLD,
  MINIMUM_ROLL_ANGLE_THRESHOLD,
  MAXIMUM_ROLL_ANGLE_THRESHOLD,
  DEFAULT_ACTIONS_VALUE,
}
